(ns kyber.components.forms.passwordless-sign-in
  (:require [re-frame.core :as re-frame]
            [reagent-form.core :as rf]
            [reagent-form.validators :as v]
            [reagent-form.transformers :as t]

            [kyber.i18n.core :as i18n]
            [kyber.styles.core :refer [gs styles->classes]]))

(def classes
  (styles->classes
   {:sign-in-btn {:width "100%"}
    :sign-in-form
    {:display :flex
     :align-items :flex-end

     "& > *"
     {:margin-right (gs [:spacing :p20])

      "&:last-child"
      {:margin-right (gs [:spacing :p0])}}

     "& .reagent-form-field"
     {:flex-grow 1
      (gs [:queries :mobile-landscape])
      {:width "100%"}}

     "& .reagent-form-submit-button"
     {:margin-bottom (gs [:spacing :p8])}

     "& .reagent-form-submit-button-container .reagent-form-errors"
     {:display :none}

     (gs [:queries :mobile-landscape])
     {:flex-direction :column
      :align-items :flex-start

      "& > *"
      {:margin-right (gs [:spacing :p0])}}}}))

(defn render
  ([] [render {}])
  ([{:keys [email]}]
   (let [sign-in-event :authentication/passwordless-sign-in
         is-submitting (re-frame/subscribe
                         [:request/is-dispatching sign-in-event])]
     [:<>
      [rf/form {:id            sign-in-event
                :is-submitting is-submitting}
       [:form
        {:class
         (:sign-in-form classes)

         :rf/form
         {:on-submit #(do
                        (re-frame/dispatch [:gdpr/acknowledge :sign-in])
                        (re-frame/dispatch [sign-in-event %]))}}

        (rf/input
          (cond-> {:field-key :email
                   :type :text
                   :label (i18n/t* ::label)
                   :validators [{:validator v/required
                                 :message (i18n/t* ::validator-required)}
                                {:validator v/simple-email
                                 :message (i18n/t* ::validator-invalid)}]
                   :transformers [t/trim
                                  t/ensure-lower]}
            (some? email)
            (assoc :default-value email)))

        (rf/submit-button
          {:default-text        (i18n/t* ::submit)
           :submit-button-class (:sign-in-btn classes)})]]])))
